import { combineReducers } from "redux";
import menagePlaylist from "./menagePlaylist";
import libraryPopups from "./popups";

import user from "./user";

export default combineReducers({ menagePlaylist, libraryPopups, user });
